import type { AttributesEntity } from '@eliadmin/core/src/api/products/types/product-types';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@eliadmin/core/src/components/ui/select';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';

/** TODO: handle when no value is present */
export function ProductVariantSelect({ attribute }: { attribute: AttributesEntity }) {
  const selectedValues = useVariantsStore(state => state.selectedValues);
  const updateSelectedValue = useVariantsStore(state => state.updateSelectedValue);

  const selectedValue = selectedValues.find(
    selectedValue => selectedValue.attribute.id === attribute.id,
  );

  const handleValueChange = (newValue: string) => {
    const selectedValue = attribute.values?.find(value => String(value.id) === String(newValue));
    if (selectedValue) {
      updateSelectedValue({ attribute, value: selectedValue });
    }
  };

  return (
    <Select value={String(selectedValue?.value.id) ?? undefined} onValueChange={handleValueChange}>
      <div
        className={cn(
          'flex w-full flex-col justify-end gap-2 border-none sm:max-w-[424px]',
          'ea-product-detail-variant__select-wrapper',
        )}
      >
        <SelectTrigger
          className={cn('rounded-lg bg-input')}
          isClearable={!!selectedValue}
          rounded="default"
          onClear={() => {
            if (!selectedValue) return;
            handleValueChange(String(selectedValue!.value.id));
          }}
        >
          <SelectValue className={cn('', 'ea-product-detail-variant__select-value')} />
        </SelectTrigger>
      </div>
      <SelectContent className={cn('', 'ea-product-detail-variant__select-content')}>
        {attribute.values?.map(value => {
          return (
            <SelectItem
              key={`select-attribute-${attribute.id}-value-${value.id}`}
              value={String(value.id)}
              className={cn('cursor-pointer', 'ea-product-detail-variant__select-item')}
            >
              {value.name}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}
